// src/pages/Login.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import UpdateContact from './UpdateContact';
const ContractTable = (props) => {

    const [updateContract, setUpdateContract] = useState(null);
    const [openUpdateContract, setOpenUpdateContract] = useState(false);
    const { contracts, tab, setNewContractAdded } = props;
    const handleClickUpdateButton = (contract) => {
        setUpdateContract(contract);
        setOpenUpdateContract(true);
    }

    return (

        <div className="flex flex-col w-full overflow-y-scroll h-[91vh]">
            {openUpdateContract && <UpdateContact
                openModal={() => setOpenUpdateContract(false)}
                isNewContract={false}
                updateContract={updateContract}
                setNewContractAdded={setNewContractAdded}
                tab={tab}
            />}
            <div className="px-4 sm:px-6 lg:px-8">
                <div className="mt-8 flow-root">
                    <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                            <table className="min-w-full divide-y divide-gray-300">
                                <thead>
                                    <tr>
                                        <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                                            Serial Number
                                        </th>
                                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                            Certificate Name
                                        </th>
                                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                            Actions
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200">
                                    {contracts.map((contract) => (
                                        <tr key={`${contract.serial_number}/${contract.id}`} className=''>
                                            <td className="whitespace-normal break-all text-sm font-medium text-gray-900 sm:pl-0 w-[20%] ">
                                                {contract.serial_number}
                                            </td>
                                            <td className="whitespace-normal break-all text-sm text-gray-500 sm:w-[10%] md:w-[70%]">
                                                <div className='w-full'>
                                                    {contract.file_name}
                                                </div>
                                            </td>
                                            <td className="text-right text-sm font-medium sm:w-[20%] md:w-[10%]">
                                                <div className='w-full flex flex-row gap-2'>

                                                    <a href="#" onClick={(e) => { handleClickUpdateButton(contract); }} className="">
                                                        EDIT
                                                    </a>

                                                    <a href="#" onClick={() => {
                                                        window.open(contract.url, "_blank");
                                                    }} className="">
                                                        DOWNLOAD
                                                    </a>

                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default ContractTable;